import { getItem } from './storage';

export const getCoreAuthHeader = () => {
  const accessToken = getItem('coreApiAccessToken');
  if (!accessToken) return {};
  return { Authorization: `Bearer ${accessToken}` };
};
